import React from 'react'
import BulletPoint from '../../../../../components/bulletPoint/BulletPoint'

import PricesData from './Prices'

import './PaymentDetails.scss'

const PaymentDetails = ({ state }) => {
  let data = PricesData[state.type].filter((item) => item.type === state.subtype)
  data = data[0]
  return (
    <div className="paymentDetails">
      <div className="paymentDetails__overview">Order Overview</div>
      <div className="paymentDetails__title">{data?.title}</div>
      {data?.features.map((data) => (
        <BulletPoint type="regular" item={data} />
      ))}
      <hr />
      <div className="paymentDetails__price">
        ${data.price}.00 <span className="paymentDetails__duration">{data.duration}</span>
      </div>
    </div>
  )
}

export default PaymentDetails
